import {paginationMixin} from "@/domain/media/mixins";

const state = {
    photos: [],
    paginate: true,
    pagination: paginationMixin()
}

const getters = {
    photos: state => state.photos,
    paginate: state => state.paginate,
    count: state => state.pagination.count,
    page: state => state.pagination.page
}

const mutations = {
    setPhotos(state, {photos, count}) {
        state.pagination.count = count
        if (state.photos.length > 0) {
            state.photos = state.photos.concat(photos)
        } else {
            state.photos = photos
        }
    },
    resetPagination(state) {
        state.photos = []
        state.paginate = true
        state.pagination = paginationMixin()
    },
    setPaginate(state, paginate) {
        state.paginate = paginate
    },
    incrementPagination(state, isEnd) {
        // trick to force reactivity
        if (isEnd) {
            state.pagination.page = 1
            return
        }
        state.pagination.page += 1
    },
}

export const actions = (mediaService) => ({
        async fetchPhotos(context, params) {
            params = {
                all: true,
                page: state.pagination.page,
                page_size: state.pagination.page_size,
                ...params
            }
            const response = await mediaService.getMedias(params)
            context.commit('setPhotos', {
                photos: response.results,
                count: response.count
            })
            if (response.next === null) {
                context.commit('setPaginate', false)
                context.commit('incrementPagination', true)
            } else {
                context.commit('incrementPagination')
            }
            return response.results
        }
    }
)


export default mediaService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(mediaService)
})